import { MessageSquare, Sparkles } from "lucide-react";

const Solution = () => {
  return (
    <section className="py-16 px-4 sm:px-6 bg-secondary/50">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-center gap-6 mb-8">
          <div className="flex-shrink-0">
            <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center">
              <Sparkles className="h-8 w-8 text-primary" />
            </div>
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-primary">Made-Convers•IA:</span> Tu Socio Estratégico en IA Conversacional
            </h2>
          </div>
        </div>
        
        <div className="bg-card border border-border rounded-xl p-6 sm:p-8 md:p-10 shadow-lg">
          <div className="flex flex-col sm:flex-row items-start gap-4 mb-6">
            <MessageSquare className="h-8 w-8 text-primary flex-shrink-0 mt-1" />
            <div className="space-y-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
              <p>
                La <span className="text-foreground font-semibold">inteligencia artificial conversacional</span> permite
                que el software comprenda y responda de forma natural a conversaciones humanas, por texto o voz.
              </p>
              <p>
                Ofrece distintas opciones de voz —incluso personalizadas— y es capaz de interpretar el lenguaje
                natural para mantener <span className="text-success font-semibold">diálogos fluidos, adaptables
                y casi indistinguibles de los humanos</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
